import { pushEvent, pushGA4Event } from './helpers';

/** domain list for GMS domains */
const domainList = ['tcgms.net', 'zmaildir.com'];
/** checks if the origin of the iframe is on the domainList */
const validDomain = (e) => {
  return domainList.reduce((contains, domain) => {
    return contains || e.origin.includes(domain);
  }, false);
};

/** main selector: class that the plugin adds, and also need to have an iframe in */
const mainSelector = '.plugin-gms-form iframe';
/** checks if we have the plugin in the page */
const elementsToTrack = () => {
  let GMSiframes = document.querySelectorAll(mainSelector);
  return !GMSiframes ? false : [...GMSiframes];
};

/**
 * receive the message from gms iframe
 * @param {object} e
 * @param {object} EventTracking
 */
const handleGMSMessage = ({ e, EventTracking }) => {
  if (!validDomain(e) || !JSON.parse(e.data)?.formData?.iframeSrc) return;

  let iframeSRCFromMessage = JSON.parse(e.data).formData.iframeSrc;
  let GMSiframe = elementsToTrack().find(
    (iframe) => iframe.src.replace(/(^\w+:|^)\/\//, '') === iframeSRCFromMessage.replace(/(^\w+:|^)\/\//, '')
  );

  let msg = {
    category: 'Form submission',
    action: `${GMSiframe.parentNode.parentNode.parentNode.dataset.formType} form`,
    label: `Submitted on: ${EventTracking.pageSection} _ ${EventTracking.pagePathURL}`
  };

  let optional = {
    iframeURL: iframeSRCFromMessage
  };
  pushEvent(msg, optional);

  let formType = 'generic';
  if (GMSiframe.parentNode.parentNode.parentNode.dataset.formType === 'RFP') {
    formType = 'rfp';
  } else if (GMSiframe.parentNode.parentNode.parentNode.dataset.formType === 'Contact') {
    formType = 'contact';
  } else if (GMSiframe.parentNode.parentNode.parentNode.dataset.formType === 'Newsletter') {
    formType = 'newsletter';
  }

  pushGA4Event({
    eventName: 'contact',
    eventData: {
       method: 'form',
       form_type: formType
    }
  });
};

const GMSFormEventListener = (EventTracking) => {
  if (!elementsToTrack()) return;
 
  window.addEventListener('message', (event) => {
    handleGMSMessage({ e: event, EventTracking });
  });
};

export { GMSFormEventListener };
